<div [hidden]="!message" class="alert alert-{{type}}" role="alert" #alertNotice>
	<div class="alert-text" [innerHTML]="message"></div>
</div>
